<template>
  <div class="appHeader">
    <div class="header-left">
      <i
        class="collapse-icon"
        :class="sidebarCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
        @click="toggleSidebar"
      />
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          :to="{ path: p.path }"
          v-for="p in initBreadCrumbs()"
          :key="p.path"
        >
          {{ $menuLabel(p.path, p.title) }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="header-actions" data-tour="header-actions">
      <span class="header-action-item" @click="handleCheckUpdate">
        <i class="el-icon-refresh" />
        {{ $t("header.checkUpdate") }}
      </span>
      <span class="header-action-divider" />
      <span class="header-action-item" @click="handleForceReload">
        <i class="el-icon-refresh-right" />
        {{ $t("header.forceReload") }}
      </span>
      <span class="header-action-divider" />
      <LanguageSwitch />
      <span class="header-action-divider" />
      <el-dropdown
        class="userNameDrop"
        placement="bottom"
        @command="handleCommand"
      >
        <span class="userName">
          <el-avatar
            v-if="!loginAccountInfo.is_manage && loginAccountInfo.image_path"
            :size="24"
            :src="loginAccountInfo.image_path"
            class="header-avatar"
          />
          <i v-else class="iconfont icon-user" />
          {{ loginAccountInfo.cn_name }}
        </span>
        <el-dropdown-menu slot="dropdown" class="userDropMenus">
          <el-dropdown-item v-if="!loginAccountInfo.is_manage" command="personal">{{ $t("header.personal") }}</el-dropdown-item>
          <el-dropdown-item command="logout">{{ $t("header.logout") }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import LanguageSwitch from "@/components/LanguageSwitch.vue";
import _ from "lodash";
import routes from "@/router/routes";
import { flattenRoute } from "@/utils/menu";
import { mapState } from "vuex";
import { removeCookie } from "@/utils/utils";
import { checkAppVersion, forceReloadApp } from "@/utils/appVersion";
export default {
  components: { LanguageSwitch },
  computed: mapState(["loginAccountInfo", "sidebarCollapsed"]),
  methods: {
    toggleSidebar() {
      this.$store.commit("toggleSidebar");
    },
    initBreadCrumbs() {
      const arr = _.compact(this.$route.path.split("/"));
      const joinPaths = arr.reduce((re, item, index) => {
        const p = `${index == 0 ? "" : re[index - 1].path}/${item}`;
        const pathObj = flattenRoute(routes).find((i) => i.path == p);
        if (pathObj) {
          re.push(pathObj);
        }
        return re;
      }, []);
      return joinPaths;
    },
    handleCheckUpdate() {
      checkAppVersion({ forceNotify: true }).catch(() => {});
    },
    handleForceReload() {
      forceReloadApp();
    },
    handleCommand(c) {
      if (c == "personal") {
        this.$router.push("/personal");
        return;
      }
      if (c == "logout") {
        removeCookie("loginAccountInfo");
        sessionStorage.removeItem("routesData");
        this.$store.commit("clearLoginAccount");
        this.$store.commit("clearVisitedViews");
        this.$router.push("/login");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.appHeader {
  color: #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 12px 0 8px;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  .header-left {
    display: flex;
    align-items: center;
    min-width: 0;
  }
  .collapse-icon {
    font-size: 20px;
    cursor: pointer;
    padding: 0 12px;
    color: #5a5e66;
    &:hover {
      color: #1890ff;
    }
  }
  .header-actions {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }
  .header-action-item {
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #333;
    padding: 0 12px;
    &:hover {
      color: #1890ff;
    }
    i {
      font-size: 16px;
      margin-right: 6px;
    }
  }
  .header-action-divider {
    width: 1px;
    height: 16px;
    background: #dcdfe6;
    margin: 0 4px;
  }
  .userNameDrop {
    .userName {
      cursor: pointer;
      font-size: 14px;
      display: flex;
      align-items: center;
      padding-right: 12px;
      &:hover {
        color: #1890ff !important;
      }
      .iconfont {
        font-size: 16px;
        margin-right: 6px;
      }
      .header-avatar {
        margin-right: 6px;
      }
    }
  }
}
</style>
<style lang="scss">
.userDropMenus {
  .el-dropdown-menu__item {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    width: 140px;
    text-align: center;
  }
}
</style>
